export enum ErrorCodes {
  NO_BEGIN_MARKER = "NO_BEGIN_MARKER",
  FIX_FIELDS_SEPARATOR_NOT_FOUND = "FIX_FIELDS_SEPARATOR_NOT_FOUND",
  FIX_TAG_VALUE_NOT_FOUND = "FIX_TAG_VALUE_NOT_FOUND",
  FIX_TAG_KEY_IS_NOT_NUMBER = "FIX_TAG_KEY_IS_NOT_NUMBER",
  INVALID_CHECKSUM = "INVALID_CHECKSUM",
  DATA_FIELD_LENGTH_MISSING = "DATA_FIELD_LENGTH_MISSING",
  INVALID_IDENTITY = "INVALID_IDENTITY",
}
